document.addEventListener('click', (e) => {
    if (e.target.classList.contains('expand-nav')) {
        const asideNavContainer = document.querySelector('#aside-nav-container')
        const asideNav = asideNavContainer.querySelector('nav')
        if (!asideNavContainer.classList.contains('expanded')) {
            const top = asideNav.getBoundingClientRect().top
            const left = asideNav.getBoundingClientRect().left
            const width = asideNavContainer.getBoundingClientRect().width
            asideNav.style.top = `${top}px`
            asideNav.style.left = `${left}px`
            asideNav.style.width = `${width}px`
            asideNavContainer.classList.add('expanded')
        } else {
            asideNav.style.top = `0px`
            asideNav.style.left = `0px`
            asideNav.style.width = `100%`
            asideNavContainer.classList.remove('expanded')
        }
    }
})

function handleAsideNav() {
    const asideNavContainer = document.querySelector('#aside-nav-container')
    if (!asideNavContainer) return
    const asideNav = asideNavContainer.querySelector('nav')

    if (window.innerWidth > 640) {
        if (asideNavContainer.classList.contains('expanded')) {
            const top = asideNavContainer.getBoundingClientRect().top
            const left = asideNavContainer.getBoundingClientRect().left
            const width = asideNavContainer.getBoundingClientRect().width
            asideNav.style.top = `${top}px`
            asideNav.style.left = `${left}px`
            asideNav.style.width = `${width}px`
        }
    }

    if (window.innerWidth < 640) {
        asideNavContainer.setAttribute('data-modal_id', 'aside-nav')
    } else {
        asideNavContainer.removeAttribute('data-modal_id')
    }
}

document.addEventListener('DOMContentLoaded', handleAsideNav)
window.addEventListener('resize', handleAsideNav)

window.addEventListener('scroll', (e) => {
    const asideNavBtn = document.querySelector('[data-toggle_modal="aside-nav"]')
    if (!asideNavBtn) return
    const asideNavBtnTop = asideNavBtn.parentElement.getBoundingClientRect().top

    // Check if the button is 60px from the top of the viewport
    if (asideNavBtnTop < 68) {
        asideNavBtn.classList.add('fixed')
    } else {
        asideNavBtn.classList.remove('fixed')
    }
})
